export default __webpack_public_path__ + "static/media/PL001.cd856965.mp3";